import { LogoStyle } from "./../context/LogoStyleContext";
import { useContext } from "react";
import { useMount } from "react-use";
import { LogoStyleContext } from "../context/LogoStyleContext";

export const useSetLogoStyle = (style: LogoStyle) => {
  const { setLogoStyle } = useContext(LogoStyleContext);

  useMount(() => {
    setLogoStyle(style);
  });
};
